import React from "react";

import Sidebar from "../components/Sidebar/Sidebar";
import RightBar from "../components/RightBar/RightBar";
import GameCard from "../components/GamesCard/GameCard";
import TopGameVendor from "../components/TopGameVendor";

const MainHome = () => {
  return (
    <>
      <div className="flex justify-between">
        <div className="left w-[17%] hidden md:block">
          <Sidebar />
        </div>
        <div className="right w-[100%] md:w-[83%]">
          <RightBar />
          {/* game card section */}
          <div className="!mt-[10px] px-[2px]">
            <TopGameVendor />
          </div>
          <section className="!pr-[5px] !mt-[-10px] !pl-[5px]">
            <div className="mt-2">
              <p className="font-bold text-[14px]">Top Games</p>
            </div>
            <div className="grid gap-1.5  main-card !mt-2 grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 md:!p-0 !pt-0">
              <GameCard />
              <GameCard />
              <GameCard />
              <GameCard />
              <GameCard />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default MainHome;
